<template>
  <div v-if="storeListData.length > 0">

    <b-table-simple class="text-center" responsive>
      <b-thead head-variant="light">
        <b-tr>
          <b-th>카카오톡 채널</b-th>
          <b-th>파트너명</b-th>
          <b-th v-if="currentUser.userRole === 'BRAND_ADMIN'">연동신청 매장</b-th>
          <b-th>입점상태</b-th>
          <b-th>신청정보</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(item, idx) in storeListData" :key="idx">
          <b-td>{{ item.channelName }} ({{ item.channelId }})</b-td>
          <b-td>{{ item.partnerName }}</b-td>
          <b-td v-if="currentUser.userRole === 'BRAND_ADMIN'">
            <template v-for="(snItem, idx) in item.storeNames">
              <span>{{ snItem }}</span><br>
            </template>
          </b-td>
          <b-td>
            <h6 v-if="item.registerStatus === 'RegisterRequest'"><span class="badge badge-disabled">심사중</span></h6>
            <h6 v-if="item.registerStatus === 'Approve'"><span class="badge badge-confirm">입점완료</span></h6>
            <h6 v-if="item.registerStatus === 'Reject'">
              <span v-b-modal.modalsm class="badge badge-rejected" @click="openRejectReasonModal(item.lastRejectReason)">심사반려
                <i class="simple-icon-question font-weight-bold"></i>
              </span>
            </h6>
          </b-td>
          <b-td>
            <b-button
              v-if="item.registerStatus !== 'RegisterRequest' && getRegisterBy(item.registerBy)"
              size="sm" variant="outline-primary"
              @click="modifyKakaoReserve(item.kakaoId,item.id, item.registerStatus)">
              수정
            </b-button>
            <b-button
              v-if="item.registerStatus !== 'RegisterRequest' && getRegisterBy(item.registerBy) && item.registerStatus !== 'Approve'"
              size="sm" variant="outline-dark"
              @click="cancelKakaoReserve(item.id)">
              신청취소
            </b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>

    <b-modal ref="rejectReason" size="md" title="심사반려 사유" hide-footer>
      <b-form-row>
        <b-form-textarea disabled :rows="7" :max-rows="7" v-model="rejectReason" />
      </b-form-row>
    </b-modal>

  </div>
</template>

<script>


import {mapGetters} from "vuex";
import api from "@/constants/api";

export default {
  components: {},
  data() {
    return{
      allCheck:false,
      storeListData : [],
      storeSelectList: [],
      storeOptionData:[],
      infoData:{},
      rejectReason:"",
    }
  },
  computed: {
    ...mapGetters([ 'siteName', 'currentUser','info'])
  },
  mounted() {

    this.getInfo();
    this.getList();
    // popover 위치 관련 추가 작업 해야함
    // document.getElementsByClassName('bs-popover-top').style
  },
  watch: {
    // allCheck(chk) {
    //   if(chk == true){
    //     this.storeOptionData.forEach(item=>{
    //       if(item.useYN == true){
    //         item.status=true
    //       }
    //
    //     })
    //   }else if(chk == false){
    //     this.storeOptionData.forEach(item=>{
    //       if(item.useYN == true){
    //         item.status=false
    //       }
    //     })
    //   }
    // },
  },
  methods:{
    getInfo(){
      //siteInfoData
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteInfoData)
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          this.infoData = res.data.data

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },
    getList(){
      this.storeOptionData = []
      let reqURL = ''
      if (this.currentUser.userRole === 'BRAND_ADMIN') {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.kakaoPartnerListBRD)
      }else{
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.kakaoPartnerListSTR)
      }

      // const params =
      //   {"site_name": this.siteName}
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          this.storeListData = res.data.data
          this.$emit('get-list',this.storeListData)

          console.log(this.storeListData)
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },
    getRegisterBy(val) {
      console.log("=====valvalvalval=====");
      console.log(val);

      let register = val.split("/");
      console.log(this.info.username);
      console.log(this.siteName);
      console.log(register);
      if(register[0] === this.info.username && register[1] === this.siteName) {
        return true;
      } else {
        return false;
      }
    },
    cancelKakaoReserve(val){
      let reqURL = ''
      if(confirm("입점신청을 취소하시겠습니까?")){
        // cancelKakaoReserve
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.cancelKakaoReserve+'?partnerId='+val)
        this.$http.get(reqURL,  {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {

            this.$router.go(0);
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      }
    },
    modifyKakaoReserve(val,val2,status){
      if(status == 'Approve'){
        this.$router.push(`${'/'+this.siteName+'/booking/kakao-chennel-partner-view?kakaoId='+val+'&partnerId='+val2}`)
      }else{
        this.$router.push(`/${this.siteName}/booking/kakao-chennel-reg?partnerId=${val2}`);
      }


    },

    openRejectReasonModal(val) {
      this.rejectReason = ""
      this.rejectReason = val
      this.$refs['rejectReason'].show();
    },

  }
}
</script>



<style>

.badge-rejected {
  cursor: pointer;
}

</style>
